import { createSelector } from "reselect";

const isLoggedIn = state => state.loggedIn;
const getError = state => state.error;
const getUser = state => state.user;

export default {
    isLoggedIn,
    getError,
    getUser,
    userId: createSelector(getUser, user => user.id),
    userLastLogin: createSelector(getUser, user => user.last_login),
    userIsSuperuser: createSelector(getUser, user => user.is_superuser),
    userUsername: createSelector(getUser, user => user.username),
    userFirstName: createSelector(getUser, user => user.first_name),
    userLastName: createSelector(getUser, user => user.last_name),
    userEmail: createSelector(getUser, user => user.email),
    userIsStaff: createSelector(getUser, user => user.is_staff),
    userIsActive: createSelector(getUser, user => user.is_active),
    userDateJoined: createSelector(getUser, user => user.date_joined),
    userGroups: createSelector(getUser, user => user.groups),
    userPermissions: createSelector(getUser, user => user.user_permissions)
};
